import Wrapper from "../components/Wrappers/Wrapper";
import RegionContainer from "../features/Region/RegionContainer";

const Region = () => {
  return (
    <Wrapper>
      <RegionContainer />
    </Wrapper>
  );
};

export default Region;
